module.exports = __webpack_public_path__ + "media/src/ui/icons/iconMagnifyingGlass-82d8a00801c60e082cb520eac51dc8e0.png";